import styled from 'styled-components'

export const Container = styled.div`
  min-height: 250px;
  padding-left: 4px;
  margin-left: auto;
`